import { IntlShape } from 'react-intl';

const getLocalizedCarMakeName = (make: string, intl: IntlShape): string => {
  switch (make) {
    case 'Mercedes-Benz':
      return intl.formatMessage({
        defaultMessage: 'Mercedes-Benz',
        id: 'Pg4cfc',
        description: 'Make Mercedes-Benz',
      });
    case 'Mercedes-Maybach':
      return intl.formatMessage({
        defaultMessage: 'Mercedes-Maybach',
        id: 'hxZvyj',
        description: 'Make Mercedes-Maybach',
      });
    case 'BMW':
      return intl.formatMessage({
        defaultMessage: 'BMW',
        id: 'JGFgoE',
        description: 'Make BMW',
      });
    case 'GMC':
      return intl.formatMessage({
        defaultMessage: 'GMC',
        id: 'global_make_gmc',
        description: 'Make GMC',
      });
    case 'Cadillac':
      return intl.formatMessage({
        defaultMessage: 'Cadillac',
        id: 'global_make_cadillac',
        description: 'Make Cadillac',
      });

    default:
      return make;
  }
};

export { getLocalizedCarMakeName };
